import { Component, Input, OnInit, ViewChild, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { CartService } from 'src/app/services/cart.service';
import { ReportService } from 'src/app/services/report.service';
import { CommonConfig } from 'src/app/shared/common-config/common-config';

@Component({
  selector: 'products-overview',
  standalone: true,
  imports: [CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatCardModule,
    SharedModule,
    NgOptimizedImage,
    TranslateModule
  ],
  templateUrl: './products-overview.component.html',
  styleUrls: ['./products-overview.component.scss'],
//   animations: [
//     trigger('activate', [
//         state('true', style({ opacity: 1, transform: 'translateX(0px)', zIndex: 1, pointerEvent:'auto'})),
//         state('false', style({ opacity: 0, transform: 'translateX(100px)',zIndex: 0 , pointerEvent: 'none'})),
//         transition('false => true', animate('0.7s')),
//         transition('true => false', animate('0.4s')),
//     ])
// ]
})
export class ProductsOverviewComponent implements OnInit {
  panelOpenState: boolean = true;
  activePanel: string = 'report';
  multipleAccordion: boolean = false;
  titletag: string = 'Conosci il tuo business';
  productReport$ = signal<{ name: null, price: null } | null>({ name: null, price: null })
  productReport?: { name: null, price: null };
  @Input() layout!: 'a'|'b';
  // @Input() company:any

  @ViewChild(MatAccordion) accordion!: MatAccordion;
  downloadingdemo: boolean = false;

  

  constructor(private router: Router,
    private cartService: CartService,
    private reportService: ReportService,
    private commonConfig: CommonConfig,) {
   
  }
  
  ngOnInit(): void {
    
    // console.log(this.activePanel)
    this.initLayout();
  }

  initLayout() {
    if (!this.layout) {
      this.layout = this.commonConfig.getDashboardLayout() as 'a' | 'b';
    }
    if (this.layout === 'b') { 
      // this.productReport$.set(null)
      // this.productReport = null
    } else {
      this.reportService.getReportBundle().then((res: any) => {
      if(!res?.reportDigitale?.name) return
      let product = {
        name: res.reportDigitale.name,
        price:res.reportDigitale?.price ?? res.reportDigitale.variations.find((el:any) => el.sku === 'report-digitale-basic')?.price ?? null
      }
        // this.productReport$.set(product)
        this.productReport = product
    })
    }
  }
  setActivePanel(idpanel: string) {
    this.activePanel = idpanel
    // this.panelOpenState = !this.panelOpenState
    // console.log(this.activePanel)
    switch (this.activePanel) {
      case 'report':
      this.titletag = 'Conosci il tuo business';
        break;
      case 'services':
        this.titletag = 'L\'innovazione si sostiene';
        break;
      case 'marketplace':
        this.titletag = 'Soluzioni per il tuo business';
        break;
      default:
        this.titletag = 'Conosci il tuo business';
        break;
    }
  }

  getProductAction(id: string) {
    // console.log(id)
    switch (id) {
      case 'marketplace':
      case 'services':
        this.goToMarketplace();
        break;
      case 'report':
        this.goToReport();
        break;
    
      default:
        break;
    }
  }

  goToMarketplace() {
    let basePath = environment.routingBasePath;
		this.router.navigate([basePath + '/marketplace'])
  }

  goToReport() {
    let basePath = environment.routingBasePath;
    this.router.navigate([basePath + '/digital-report'])
  }

  // getBasicReport() {
  //   if (!this.company?.alternateSummary?.vatRegistrationNumber) {
  //     return;
  //   }
  //   let piva = this.company.alternateSummary?.vatRegistrationNumber;
  //   const data =
	// 					{
	// 						// pid: 11300,
	// 						name: 'Basic',
	// 						price: 30,
	// 						sku: 'report-digitale',
  //         		variationSku: 'report-digitale-basic',
	// 						params: {
	// 							piva: piva,
	// 							thwepof_options: {
	// 								piva: {
	// 									name: 'piva',
	// 									value: piva,
	// 									type: "inputtext",
	// 									label: 'Partita IVA',
	// 									options: ''
	// 								}
	// 							}
	// 						}
	// 					}


	// 					this.cartService.addToCart(data).then((res: any) => {
	// 						this.cartService.checkout(true);
	// 					})
  // }
  
  getDemo() {
    this.downloadingdemo = true
      this.reportService.dowloadDemo().then((res:any)=>{
        // console.log(res);
        this.downloadingdemo = false
      });
  }





}
